import { useParams } from 'react-router-dom';
import { useNavegate } from 'App/hooks';
import {
  ErrorScreen,
  HeaderContent,
  HeaderTop,
  IonPageStratus,
} from 'commons/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { ProductsTransferCard, SourceDestinationCard } from './components';
import { useGetTransferByIdQuery } from '../../transfersApi';
import SourceDestinationCardSkeleton from '../components/SourceDestinationCardSkeleton';

function DetailTransferPage() {
  const { id } = useParams<{ id: string }>();
  const t = useTranslationCatalog();
  const {
    data: transfer,
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useGetTransferByIdQuery(id);
  const { goBack } = useNavegate();

  return (
    <IonPageStratus
      headerTop={<HeaderTop navigation={{ onClick: goBack }} />}
      width="medium"
      headerContent={
        <HeaderContent
          title={
            transfer
              ? `${t('transfers.detail.title')} #${transfer.number}`
              : t('transfers.detail.title')
          }
        />
      }
    >
      {isLoading && <SourceDestinationCardSkeleton />}
      {isError && <ErrorScreen onRetry={refetch} />}
      {isSuccess && !!transfer && (
        <>
          <SourceDestinationCard
            sourceLocation={transfer.originLocation}
            destinationLocation={transfer.destinationLocation}
          />
          <ProductsTransferCard productVariants={transfer.productVariants} />
        </>
      )}
    </IonPageStratus>
  );
}

export default DetailTransferPage;
